import { combineReducers } from 'redux';
import rfq from 'Reducers/rfq';
import contracting from 'Reducers/contracting';
import constants from 'Reducers/constants';
import common from 'Reducers/common';
import chat from 'Reducers/chat';
import authentication from 'Reducers/authentication';
import rateComparison from "Reducers/rateComparison";
import EXIMCargoTracking from "Reducers/EXIMCargoTracking";
import supplierOrTransportationRequestsDashboard from "Reducers/supplierOrTransportationRequestsDashboard";
import supplierRFQCreateOrUpdateRequest from "Reducers/supplierRFQCreateOrUpdateRequest";
import PODetails from 'Reducers/poDetails';
const rootReducer = combineReducers({
  rfq,
  constants,
  contracting,
  common,
  chat,
  authentication,
  rateComparison,
  EXIMCargoTracking,
  supplierOrTransportationRequestsDashboard,
  supplierRFQCreateOrUpdateRequest,
  PODetails
});

export default rootReducer;
